import React, { useEffect, useState } from 'react';
import { useNCZICommandContext } from '../../Services/NCZICommandContext';
import { FinishedCommand } from '../../Commands/Command';
import Text from '../../../../Components/Base/Text/Text';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';

interface NCZICommandErrorParams {
	commandId: string;
	handleRetry?: () => void;
}

const NCZICommandError: React.FC<NCZICommandErrorParams> = params => {
	const { commandId, handleRetry } = params;
	const [error, setError] = useState<string | undefined>(undefined);

	const { commands } = useNCZICommandContext();

	useEffect(() => {
		const command = commands[commandId];
		if (command && command.state === 'error') {
			const finishedCommand = command as FinishedCommand;
			setError(finishedCommand.errorMessage);
		} else {
			setError(undefined);
		}
	}, [commands, commandId]);

	const clickRetry = () => {
		setError(undefined);
		handleRetry?.();
	};

	return (
		<div style={{ color: '#dc3545' }}>
			{error && (
				<>
					<Text tx={error} />
					{handleRetry && (
						<>
							<br />
							<Button
								onClick={clickRetry}
								title={'base.repeat'}
								theme={Theme.BLUE}
								style={{ width: 'fit-content' }}
							/>
						</>
					)}
				</>
			)}
		</div>
	);
};

export default NCZICommandError;
